export const fetchData = (stateName, commitName, fetcher) => async ({ state, commit }) => {
    if (state[stateName]) {
        return
    }

    const data = await fetcher()
    commit(commitName, data)
}

export const setData = stateName => (state, val) => {
    state[stateName] = val
}

export const generateStoreHandler = (stateName, fetcher) => {
    const uppercasedName = stateName.charAt(0).toUpperCase() + stateName.slice(1).toLowerCase()
    const commitName = `set${uppercasedName}`
    const actionName = `fetch${uppercasedName}`

    return {
        state: {
            [stateName]: null,
        },
        actions: {
            [actionName]: fetchData(stateName, commitName, fetcher),
        },
        mutations: {
            [commitName]: setData(stateName),
        },
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/constructors/index.js